<template>
    <div>
        <Transition name='fade'>
            <div style="background-color: rgba(0, 0, 0, 0.2); position:fixed; left:0px; top:0px; width:100%; height:calc(100%);" :style="{ zIndex: zIndex }" v-if="isShowTimeSelector" @click="hide"></div>
        </Transition>
        <div class="frame" :class="{ open: isShowTimeSelector }">
            <div style="display:flex; justify-content: space-between;">
                <div style="font-size: 18px; padding: 20px; padding-bottom: 0;" @click="hide">취소</div>
                <div style="color: var(--color-main); font-size: 18px; padding: 20px; padding-bottom: 0;" @click="confirm">확인</div>
            </div>
            <div style="display:flex; position: relative;" v-if="reloadFlag">
                <div style="display: flex; flex: 1; justify-content: end; position: relative; z-index: 2;">
                    <ScrollSelectorNew test="시" textLeft="72.5%" :transformX="25" :list="hours" style="height:200px; overflow:hidden; flex: 1;" :init-value='initHour' :detect-value-change="detectHourChange"></ScrollSelectorNew>
                </div>
                <div style="flex: 1; display: flex; position: relative; justify-content: start; position: relative; z-index: 2;">
                    <ScrollSelectorNew test="분" textLeft="34%" :transformX="-45" :list="mins" style="height:200px; overflow:hidden; flex: 1;" :init-value="initMin" :detect-value-change="detectMinChange"></ScrollSelectorNew>
                </div>
                <div style="background-color: #f5f5f5; width: calc(100% - 40px); z-index: 1; border-radius: 7px; height: 30px; position: absolute; left: 50%;top: 50%; transform: translate(-50%, -50%); "></div>
            </div>
        </div>
    </div>
</template>

<script>
import ScrollSelectorNew from "./ScrollSelectorNew";
import moment from 'moment';

export default {
    name: "TimeSelectorPopupNew",
    components: { ScrollSelectorNew },
    props: {
        hide: {
            type: Function,
            default: () => { }
        },
        isShowTimeSelector: {
            type: Boolean,
            default: false
        },
        startTime: {
            type: String,
            default: '',
        },
        completeAction: {
            type: Function,
            default: () => { },
        },
        isShowDiscuss: {
            type: Boolean,
            default: false
        },
        zIndex: {
            type: Number,
            default: 1,
        }
    },
    watch: {
        isShowTimeSelector() {
            if (this.isShowTimeSelector) {
                this.reloadFlag = true;
                this.refresh();
            } else {
                setTimeout(() => {
                    this.reloadFlag = false;
                }, 300);
            }
        }
    },
    data() {
        return {
            hours: [],
            mins: [],
            initHour: '',
            initMin: '',
            selectedHour: '',
            selectedMin: '',
            reloadFlag: false,
        }
    },
    methods: {
        refresh() {
            this.hours = [
                { label: '00', value: '00' },
                { label: '01', value: '01' },
                { label: '02', value: '02' },
                { label: '03', value: '03' },
                { label: '04', value: '04' },
                { label: '05', value: '05' },
                { label: '06', value: '06' },
                { label: '07', value: '07' },
                { label: '08', value: '08' },
                { label: '09', value: '09' },
                { label: '10', value: '10' },
                { label: '11', value: '11' },
                { label: '12', value: '12' },
                { label: '13', value: '13' },
                { label: '14', value: '14' },
                { label: '15', value: '15' },
                { label: '16', value: '16' },
                { label: '17', value: '17' },
                { label: '18', value: '18' },
                { label: '19', value: '19' },
                { label: '20', value: '20' },
                { label: '21', value: '21' },
                { label: '22', value: '22' },
                { label: '23', value: '23' },
            ];

            const mins = [];

            // 5분 단위
            for (let i = 0; i <= 55; i = i + 5) {
                let minStr = i + '';
                if (i < 10) minStr = '0' + i;
                mins.push({ label: minStr, value: minStr });
            }

            // 10분 단위
            // for (let i = 0; i <= 50; i = i + 10) {
            //     let minStr = i + '';
            //     if (i < 10) minStr = '0' + i;
            //     mins.push({ label: minStr, value: minStr });
            // }

            // // 15분 단위
            // for (let i = 0; i <= 50; i = i + 15) {
            //     let minStr = i + '';
            //     if (i < 10) minStr = '0' + i;
            //     mins.push({ label: minStr, value: minStr });
            // }

            // 30분 단위
            // for (let i = 0; i <= 50; i = i + 30) {
            //     let minStr = i + '';
            //     if (i < 10) minStr = '0' + i;
            //     mins.push({ label: minStr, value: minStr });
            // }



            this.mins = mins;

            if (this.startTime) {
                let hour = parseInt(this.startTime.substr(0, 2));
                this.initHour = (hour < 10) ? '0' + hour : hour + '';
                this.initMin = this.startTime.substr(3, 2);
            } else {
                let hour = parseInt(moment().format('HH'));
                this.initHour = (hour < 10) ? '0' + hour : hour + '';
                this.initMin = '10';
            }

        },
        detectHourChange(selectedData) {
            this.selectedHour = selectedData.value;
        },
        detectMinChange(selectedData) {
            this.selectedMin = selectedData.value;
        },
        confirm() {
            let timeStr = '';
            let hour = parseInt(this.selectedHour);
            if (hour < 10) hour = '0' + hour;

            timeStr = hour + ':' + this.selectedMin;
            this.completeAction(timeStr);
            this.hide();
        },
        discuss() {
            this.completeAction('협의');
            this.hide();
        }

    },
    created() {
        this.refresh();
    }
}
</script>

<style scoped>
.frame {
    background-color: #fff;
    padding-bottom: 20px;
    border-radius: 20px;
    position: fixed;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    transition: 0.5s all;
    z-index: 20;
    /* text-align: center; */
    font-weight: 500;
    width: 350px;
}

.frame.open {
    top: 50%;
    transform: translate(-50%, -50%);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}
</style>